(function(){
  // Script kann mehrfach eingebunden sein (Block mehrfach auf einer Seite) – nur einmal ausführen
  if (window.__ugcWidgetLoaded) return;
  window.__ugcWidgetLoaded = true;

  var uid = 0;

  function isVideoFile(url){
    return /\.(mp4|webm|ogg|m4v|mov)(\?|#|$)/i.test(url || "");
  }

  function isDriveFolder(url){
    return /drive\.google\.com\/drive\/folders\/|drive\.google\.com\/folders\//i.test(url || "");
  }

  function normalizeUrl(raw){
    if(!raw) return "";
    var url = String(raw).trim();

    // Google Drive FILE -> preview
    var m1 = url.match(/drive\.google\.com\/file\/d\/([^\/]+)\//i);
    if(m1) return "https://drive.google.com/file/d/" + m1[1] + "/preview";

    var m2 = url.match(/drive\.google\.com\/open\?id=([^&]+)/i);
    if(m2) return "https://drive.google.com/file/d/" + m2[1] + "/preview";

    var m3 = url.match(/drive\.google\.com\/uc\?id=([^&]+)/i);
    if(m3) return "https://drive.google.com/file/d/" + m3[1] + "/preview";

    // YouTube share/watch -> embed
    var yt = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\?\/]+)/i);
    if(yt && !/\/embed\//i.test(url)) return "https://www.youtube.com/embed/" + yt[1];

    // Vimeo -> player
    var vm = url.match(/vimeo\.com\/(\d+)/i);
    if(vm && !/player\.vimeo\.com/i.test(url)) return "https://player.vimeo.com/video/" + vm[1];

    return url;
  }

  function withAutoplay(url){
    if(!url) return "";
    try{
      var u = new URL(url);
      if(!u.searchParams.has("autoplay")) u.searchParams.set("autoplay","1");
      return u.toString();
    }catch(e){
      if(/autoplay=/.test(url)) return url;
      return url + (url.indexOf("?")>-1 ? "&" : "?") + "autoplay=1";
    }
  }

  function initWidget(widget){
    if(widget.dataset.ugcInit === "1") return;
    widget.dataset.ugcInit = "1";

    var widgetId = "ugc-" + (++uid);
    widget.setAttribute("data-ugc-id", widgetId);

    var viewport = widget.querySelector("[data-ugc-viewport]");
    var prevBtn = widget.querySelector("[data-ugc-prev]");
    var nextBtn = widget.querySelector("[data-ugc-next]");
    var cards = Array.prototype.slice.call(widget.querySelectorAll("[data-ugc-card]"));

    // 1. Lightbox finden
    var lightbox = widget.querySelector("[data-ugc-lightbox]");

    // 2. Lightbox verschieben (damit sie über den Tabs liegt)
    if (lightbox && lightbox.parentElement !== document.body) {
      lightbox.setAttribute("data-ugc-owner", widgetId);
      document.body.appendChild(lightbox);
    }

    // 3. WICHTIG: Elemente jetzt IN DER LIGHTBOX suchen (statt im widget)
    // Wir nutzen hier "lightbox.querySelector" statt "widget.querySelector"
    var panel = lightbox ? lightbox.querySelector(".ugc-lightbox__panel") : null;
    var media = lightbox ? lightbox.querySelector("[data-ugc-media]") : null;
    var hint = lightbox ? lightbox.querySelector("[data-ugc-hint]") : null;

    // Achtung: querySelectorAll liefert eine Liste, daher etwas anders:
    var closeEls = lightbox ? lightbox.querySelectorAll("[data-ugc-close]") : [];

    // Lightbox Pfeile
    var lbPrev = lightbox ? lightbox.querySelector("[data-ugc-lb-prev]") : null;
    var lbNext = lightbox ? lightbox.querySelector("[data-ugc-lb-next]") : null;

    var lastFocus = null;
    var currentIndex = -1;

    function stepSize(){
      if(!cards.length) return 0;
      if(cards.length < 2){
        return cards[0].getBoundingClientRect().width;
      }
      var a = cards[0].getBoundingClientRect();
      var b = cards[1].getBoundingClientRect();
      return Math.max(0, Math.round(b.left - a.left)); // inkl. gap
    }

    function scrollByStep(dir){
      if(!viewport) return;
      var step = stepSize() || 200;
      viewport.scrollBy({ left: dir * step, behavior: "smooth" });
    }

    if(prevBtn) prevBtn.addEventListener("click", function(){ scrollByStep(-1); });
    if(nextBtn) nextBtn.addEventListener("click", function(){ scrollByStep( 1); });

    function resetHint(){
      if(!hint) return;
      hint.hidden = true;
      hint.textContent = "";
    }

    function showHint(text){
      if(!hint) return;
      hint.hidden = false;
      hint.textContent = text;
    }

    function clearMedia(){
      // altes Video sauber killen
      var oldVideo = media.querySelector("video");
      if (oldVideo) {
        oldVideo.pause();
        oldVideo.removeAttribute("src");
        oldVideo.load();
      }

      media.innerHTML = "";
      resetHint();
    }

    function renderMediaFromRaw(rawUrl){
      clearMedia();

      // Ordnerlink? -> Hinweis anzeigen (kann nicht direkt abgespielt werden)
      if(isDriveFolder(rawUrl)){
        showHint("Google‑Drive Ordnerlinks können nicht direkt abgespielt werden. Bitte hinterlege einen Datei‑Link (drive.google.com/file/d/…/view) oder eine .mp4 URL.");
        return;
      }

      var url = normalizeUrl(rawUrl);

      if(isVideoFile(url)){
        var v = document.createElement("video");
        v.setAttribute("controls","");
        v.setAttribute("playsinline","");
        v.setAttribute("preload","metadata");

        // optional: wenn du Standard-ton aus willst: v.muted = false;
        v.autoplay = false;
        v.muted = false;

        setTimeout(function () {
          v.play().catch(function(){});
        }, 50);

        v.loop = true;

        // 🔑 WICHTIG: KEIN <source>
        v.src = url;
        v.load();

        media.appendChild(v);

        // Autoplay zuverlässiger anstoßen (weil User-Geste: Klick/Swipe)
        try{ v.play().catch(function(){}); }catch(e){}
      }else{
        var iframe = document.createElement("iframe");
        iframe.src = withAutoplay(url);
        iframe.allow = "autoplay; fullscreen; picture-in-picture";
        iframe.allowFullscreen = true;
        iframe.referrerPolicy = "strict-origin-when-cross-origin";
        media.appendChild(iframe);
      }
    }

    function updateLightboxNav(){
      if(!lbPrev || !lbNext) return;
      if(cards.length <= 1){
        lbPrev.disabled = true;
        lbNext.disabled = true;
        return;
      }
      lbPrev.disabled = (currentIndex <= 0);
      lbNext.disabled = (currentIndex >= cards.length - 1);
    }

    function showIndex(idx){
      if(!cards.length) return;
      if(idx < 0 || idx >= cards.length) return;

      currentIndex = idx;

      var card = cards[idx];
      var rawUrl = card.dataset.videoUrl;
      var title = card.dataset.videoTitle || "Video";

      if(panel) panel.setAttribute("aria-label", title);

      renderMediaFromRaw(rawUrl);
      updateLightboxNav();
    }

    function openLightboxAtIndex(idx){
      lastFocus = document.activeElement;

      lightbox.hidden = false;
      lightbox.setAttribute("aria-hidden","false");
      document.documentElement.classList.add("ugc-noscroll");

      showIndex(idx);

      var closeBtn = lightbox.querySelector(".ugc-lightbox__close");
      if(closeBtn) closeBtn.focus();
    }

    function closeLightbox(){
      if(lightbox.hidden) return;
      lightbox.setAttribute("aria-hidden","true");
      lightbox.hidden = true;
      document.documentElement.classList.remove("ugc-noscroll");

      currentIndex = -1;
      clearMedia();

      if(lastFocus && typeof lastFocus.focus === "function") lastFocus.focus();
    }

    function go(delta){
      if(currentIndex < 0) return;
      var target = currentIndex + delta;
      if(target < 0 || target >= cards.length) return;
      showIndex(target);
    }

    if(lbPrev) lbPrev.addEventListener("click", function(){ go(-1); });
    if(lbNext) lbNext.addEventListener("click", function(){ go( 1); });

    closeEls.forEach(function(el){
      el.addEventListener("click", closeLightbox);
    });

    function onKeydown(e){
      if(lightbox.hidden) return;

      if(e.key === "Escape"){
        closeLightbox();
        return;
      }
      if(e.key === "ArrowLeft"){
        e.preventDefault();
        go(-1);
        return;
      }
      if(e.key === "ArrowRight"){
        e.preventDefault();
        go(1);
        return;
      }
    }
    document.addEventListener("keydown", onKeydown);

    // Aufräumen beim Neu-Rendern im Theme-Editor (shopify:section:unload)
    widget.__ugcCleanup = function(){
      closeLightbox();
      document.removeEventListener("keydown", onKeydown);
      if(lightbox && lightbox.parentElement) lightbox.parentElement.removeChild(lightbox);
    };

    // Swipe in Lightbox (mobile) – ohne externes Lib
    if(panel){
      var swipe = { active:false, startX:0, startY:0, startTime:0, pointerId:null };
      var THRESHOLD = 60;  // px
      var MAX_TIME = 800;  // ms

      function ignoreSwipeStart(target){
        return !!(target && target.closest && target.closest("[data-ugc-close],[data-ugc-lb-prev],[data-ugc-lb-next]"));
      }

      panel.addEventListener("pointerdown", function(e){
        if(lightbox.hidden) return;
        if(ignoreSwipeStart(e.target)) return;
        if(e.pointerType === "mouse" && e.button !== 0) return;

        swipe.active = true;
        swipe.pointerId = e.pointerId;
        swipe.startX = e.clientX;
        swipe.startY = e.clientY;
        swipe.startTime = Date.now();

        try{ panel.setPointerCapture(e.pointerId); }catch(err){}
      });

      panel.addEventListener("pointerup", function(e){
        if(!swipe.active) return;
        swipe.active = false;

        var dx = e.clientX - swipe.startX;
        var dy = e.clientY - swipe.startY;
        var dt = Date.now() - swipe.startTime;

        // fast + überwiegend horizontal
        if(dt <= MAX_TIME && Math.abs(dx) >= THRESHOLD && Math.abs(dx) > Math.abs(dy) * 1.2){
          if(dx < 0) go(1);
          else go(-1);
        }
      });

      panel.addEventListener("pointercancel", function(){ swipe.active = false; });
    }

    // Karten -> Lightbox öffnen (Index merken)
    cards.forEach(function(card, idx){
      card.addEventListener("click", function(){
        openLightboxAtIndex(idx);
      });
    });
  }

  // In den Body verschobene Lightboxen entfernen, deren Widget nicht mehr im DOM ist
  function removeOrphanedLightboxes(){
    document.querySelectorAll("body > .ugc-lightbox[data-ugc-owner]").forEach(function(lb){
      var owner = lb.getAttribute("data-ugc-owner");
      if(!document.querySelector('[data-ugc-id="' + owner + '"]')){
        lb.parentElement.removeChild(lb);
      }
    });
  }

  function initAll(root){
    removeOrphanedLightboxes();
    (root || document).querySelectorAll("[data-ugc-widget]").forEach(initWidget);
  }

  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", function(){ initAll(); });
  }else{
    initAll();
  }

  // Theme-Editor: Section wird bei Einstellungs-Änderungen neu gerendert
  document.addEventListener("shopify:section:load", function(e){
    initAll(e.target);
  });
  document.addEventListener("shopify:section:unload", function(e){
    e.target.querySelectorAll("[data-ugc-widget]").forEach(function(w){
      if(w.__ugcCleanup) w.__ugcCleanup();
    });
  });
})();
